import { useEffect } from "react";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { stylesActions } from "../../../../store/Styles-slice";
import { useDispatch } from "react-redux";
import { useInView } from "react-intersection-observer";
import { Link } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
// import OurServicesBox from "../../../ui/boxes/OurServicesBox";
import ServicesCard from "../../../ui/cards/ServicesCard";
import LearMoreButton from "../../../ui/buttons/LearnMoreButton";
import ul from "../../../images/ul.svg";
import AOS from "aos";
import "aos/dist/aos.css";

const OurServices = ({ content }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 500px)" });
  const dispatch = useDispatch();

  const { ref, inView } = useInView({
    threshold: 0.2,
  });

  useEffect(() => {
    if (inView) {
      dispatch(stylesActions.changeSectionName("Services"));
    }
  }, [inView, dispatch]);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
    });
  }, []);

  // Gradient colors for each service card
  // const gradientColors = [
  //   "from-blue-500 to-cyan-500",
  //   "from-purple-500 to-pink-500",
  //   "from-green-500 to-emerald-500",
  //   "from-orange-500 to-red-500",
  //   "from-pink-500 to-rose-500",
  //   "from-indigo-500 to-blue-500",
  //   "from-yellow-500 to-orange-500",
  //   "from-teal-500 to-green-500",
  //   "from-violet-500 to-purple-500",
  //   "from-emerald-500 to-teal-500",
  // ];

  return (
    <Container
      ref={ref}
      className="!bg-[#1F1F1F] xs:!pb-2  pt-14 !relative"
      id="services"
      fluid
      data-aos="fade-up"
      data-aos-once="true"
    >
      {/* Decorative Background Elements */}
      <div className="absolute top-20 left-10 w-32 h-32 bg-[#FDCF00]/20 rounded-full blur-3xl" />
      <div className="absolute bottom-20 right-10 w-40 h-40 bg-purple-500/20 rounded-full blur-3xl" />
      <div className="absolute top-1/2 left-1/4 w-24 h-24 bg-blue-500/20 rounded-full blur-2xl" />

      <Container className="!pt-14 xs:!p-0 !p-5" fluid>
        <Col>
          <Row className="!flex !items-center !justify-center !flex-col">
            <div className="text-center mb-6">
              <div className="inline-block px-4 py-2 bg-[#FDCF00]/10 rounded-full mb-4">
                <span className="text-[#FDCF00] font-medium text-sm tracking-wider uppercase">
                  Services
                </span>
              </div>
              <h3 className="!text-[36px] !font-bold !text-white !relative">
                Our <span className="text-[#FDCF00]">Services</span>
                <img
                  className="!mt-3 !absolute !left-[50%] transform -translate-x-1/2 -translate-y-1/2"
                  src={ul}
                  alt="line"
                />
              </h3>
            </div>
            <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed !mb-8">
              Our collection of tech services spans various needs at every stage of the transformation process. 
              Explore how we help businesses transform.
            </p>
          </Row>
          
          <Row className="!mt-5 xl:!mt-7 xxl:!mt-10 xs:!overflow-visible !overflow-hidden">
            <div className="!m-auto !max-w-[1676px] !grid xs:!grid-cols-1 xs:!gap-4 sm:!grid-cols-2 md:!grid-cols-2 lg:!grid-cols-3 xl:!grid-cols-5 xxl:!grid-cols-5 !gap-6 !grid-cols-5 !place-items-center">
              {content?.slice(0, 10)?.map((service, index) => (
                <div key={service.id} className="!w-full !h-full">
                  {!isMobile ? (
                    <Link
                      to={`/services/${service.slug}`}
                      className="group relative bg-white/5 backdrop-blur-sm rounded-xl hover:!border-[#FDCF00] border-2 border-transparent overflow-hidden hover:shadow-lg transition-all duration-300 hover:-translate-y-1 h-full flex flex-col"
                      data-aos="fade-up"
                      data-aos-delay={index * 100}
                      data-aos-once="true"
                    >
                      {/* Image Container */}
                      <div className="w-full h-64 relative flex-shrink-0">
                        <img
                          src={service.main_image}
                          alt={service.title}
                          className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                        />
                        {/* Gradient Overlay */}
                        {/* <div className={`absolute inset-0 bg-gradient-to-br ${gradientColors[index % gradientColors.length]} opacity-10 group-hover:opacity-20 transition-opacity duration-300`} /> */}
                      </div>

                      {/* Content */}
                      <div className="p-6 flex-1 flex flex-col justify-between">
                        <div className="space-y-3">
                          <h3 className="text-lg font-semibold text-white group-hover:text-[#FDCF00] transition-colors duration-300">
                            {service.title}
                          </h3>
                          <p className="text-sm text-gray-400 leading-relaxed line-clamp-3">
                            {service.brief_description}
                          </p>
                        </div>
                        
                        {/* Learn More Button */}
                        {/* <div className="mt-4 text-center">
                          <LearMoreButton to={`/services/${service.slug}`} />
                        </div> */}
                      </div>

                      {/* Hover overlay */}
                      <div className="absolute inset-0 bg-gradient-to-br from-[#FDCF00]/5 to-purple-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" />
                    </Link>
                  ) : (
                    <ServicesCard
                      to={`/services/${service.slug}`}
                      src={service.main_image}
                      title={service.title}
                      brief_description={service.brief_description}
                    />
                  )}
                </div>
              ))}
            </div>
          </Row>
          
          <LearMoreButton to="/services" className="!m-auto xs:!mt-8 !mt-10">
            View All
          </LearMoreButton>
        </Col>
      </Container>
    </Container>
  );
};

export default OurServices;
